import axios from 'axios';
import { CONSUMER_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getWarehouseCollection = (data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/store-customer-account-transaction',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
